export enum ForkLiftJobStatus {
    Open = 'Open',
    Pending = 'Pending',
    Completed = 'Completed',
    Cancelled = 'Cancelled',
}